export default {

    setUser(state, loginPayload) {
        state.token = loginPayload.token;
        state.currentUser = loginPayload.user;
    },
    setCurrentUserAfterUpdateProfile(state, payloadUser) {
        state.currentUser = payloadUser;
    },
    setUserVerified(state, payloadUser) {
        state.userVerified = payloadUser;
    }
};